<template>
  <div class="input-container">
    <template v-if="showType === 1">
      <div class="del" @click="delNum"><Icon type="android-remove"></Icon></div>
      <input
        type="text"
        v-model="count"
        class="input"
        :style="{ width: inputWidth + 'px' }"
        @input="changeNum()"
      />
      <div class="add" @click="addNum"><Icon type="plus"></Icon></div>
    </template>
  </div>
</template>

<script>
export default {
  name: "InputNum",
  props: {
    showType: {
      type: Number,
      required: false,
      default: 1
    },
    inputWidth: {
      type: Number,
      required: false,
      default: 30
    },
    max: {
      type: Number,
      required: false,
      default: Infinity
    },
    min: {
      type: Number,
      required: false,
      default: 1
    },
    // 遍历多个项目时，需要做下标记
    id: {
      type: Number,
      required: false,
      default: 0
    },
    num: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      count: this.num ? this.num : 1
    };
  },
  watch: {
    num: {
      handler(val) {
        this.count = val;
      },
      immediate: true
    }
  },
  methods: {
    changeNum() {
      if (this.count > this.max) {
        this.count = 1;
        this.$Modal.warning({
          content: "你输入的值超过库存量"
        });
      }
      this.changeCount();
    },
    delNum() {
      if (this.count !== this.min) {
        this.count--;
        this.changeCount();
      }
    },
    addNum() {
      if (this.count < this.max) {
        this.count++;
        this.changeCount();
      }
    },
    changeCount() {
      if (this.id) {
        this.$emit("on-change", this.count, this.id);
      } else {
        this.$emit("on-change", this.count);
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.input-container
  display flex
  .del,
  .add
    cursor pointer
    width 15px
    height 15px
    border 1px solid #ccc
    line-height 15px
    text-align center
    font-size 12px
    color #333
  .input
    text-align center
  .add
    padding-left 1px
</style>
